<ng-container *ngIf="!loading">
    <div #main [ngStyle]="{'height.px': height}" class="w-100"></div>
</ng-container>
<ng-container *ngIf="loading">
    <div [ngStyle]="{'height.px': height}" class="d-flex flex-column justify-content-center align-items-center">
        <div class="spinner-border" role="status" *ngIf="data.length != 0">
            <span class="sr-only">Loading...</span>
        </div>
        <div *ngIf="data.length == 0">
            <h1 class="text-center">No Data</h1>
        </div>
    </div>
</ng-container>